import axios from "axios";
import { UserType } from "../types/login.type";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

const getInvestorGA = async ({ token }: UserType) => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/investorGAAccountDetails`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

export default getInvestorGA;
